import './megamenucapabilities.component.scss';
import CompetitiveAnalysisMenuComponent from './components/competitiveanalysis.component';
import DemandPlanningComponent from './components/demandplanning.component';
import InsightForecastingComponent from './components/insightforecasting.component';
import OtherResourcesComponent from './components/otherresources.component';

const MegaMenuCapabilitiesComponent = () => {
  return (
    <>
      <div className="container-fluid pt-25 pb-25">
        <div className="row">
          <div className="col-lg-3">
            <InsightForecastingComponent />
          </div>
          <div className="col-lg-3">
            <CompetitiveAnalysisMenuComponent />
          </div>
          <div className="col-lg-3">
            <DemandPlanningComponent />
          </div>
          <div className="col-lg-3">
            <OtherResourcesComponent />
          </div>
        </div>
      </div>
    </>
  );
};

export default MegaMenuCapabilitiesComponent;
